












































































import { Component, Vue, Prop } from "vue-property-decorator";
import { IPlanProducts } from "@/interfaces/IPlanProduct";
import { GetProductDropDownValues, LEVEL } from "@/services/PpeDropDowns";
import { General } from "@/services/General";
import { i18n } from "@/i18n/i18n-setup";

@Component({
})
export default class PlanProductsManage extends Vue {
    @Prop({ type: Boolean, required: true })
    editable;
    @Prop({ required: true })
    planProductsProp;
    @Prop({ type: String })
    planHeaderId;
    @Prop({ type: Boolean, required: false, default: false })
    allBrandsProp;
    @Prop({ type: String, required: false })
    notesProp;

    isSaveClicked: boolean = false;
    dropDownCode4: Array<any> = [];
    dropDownCode5: Array<any> = [];
    dropDownProducts: Array<any> = [];

    completeDropDownCode5: Array<any> = [];
    completeDropDownProducts: Array<any> = [];

    isCollapseVisibile: boolean = false;

    planProducts: Array<IPlanProducts> = [];
    productsNotes: string = "";
    planProductsCount: number = 0;

    dataReady: boolean = false;
    code4: string = '';
    code5: string = '';
    idProduct: string = '';

    allBrands: boolean = false;

    level = LEVEL;

    onChangeAllBrands() {
        if(this.allBrandsProp) {
            while(this.planProducts.length) {
                this.planProducts.pop();
            }
            this.planProductsCount = 0;
            this.toggle();
        }
    }

    onChangeCostAllocationCheck(costAllocationCheck: any) {
        if(!costAllocationCheck) {
            while(this.planProducts.length) {
                this.planProducts.pop();
            }
            this.planProductsCount = 0;
            this.toggle();
        }
    }

    async mounted() {
        let product = {} as IPlanProducts;
        this.dropDownCode4 = await GetProductDropDownValues(product, LEVEL.BRAND);          
        this.completeDropDownCode5 = await GetProductDropDownValues(product, LEVEL.VARIANT);
        this.completeDropDownProducts = await GetProductDropDownValues(product, LEVEL.PRODUCT);

        this.planProducts = this.planProductsProp;
        this.planProductsCount = this.planProducts.length;

        if(this.allBrandsProp != this.allBrands) {
            this.onChangeAllBrands();
            this.allBrands = this.allBrandsProp;
        }

        this.productsNotes = this.notesProp;
        this.isCollapseVisibile = this.planProductsCount > 0;
        this.dataReady = true;
    }

    async onSelectingItem(level: number) {
        let product = {} as IPlanProducts;

        if (level == LEVEL.VARIANT as number) {
            this.dropDownProducts = null;
            this.idProduct = null;
            product.code4 = this.code4;
            this.dropDownCode5 = await GetProductDropDownValues(product, level);
        } else if (level == LEVEL.PRODUCT  as number) {
            product.code4 = this.code4;
            product.code5 = this.code5;
            this.dropDownProducts = await GetProductDropDownValues(product, level);
        }
    }

    cleanAllSelection() {
        this.dropDownCode5 = null;
        this.dropDownProducts = null;

        this.code4 = null;
        this.code5 = null;
        this.idProduct = null;
    }

    formValidation(): boolean {
        let isValid = true;
        if(!this.code4)
            isValid = false;

        return isValid;
    }

    addProduct() {
        this.isSaveClicked = true;
        if(this.formValidation()) {
            let index = this.planProducts.findIndex(x => this.normalizeCode(x.code4) === this.normalizeCode(this.code4)
                                                        && (this.normalizeCode(x.code5) === this.normalizeCode(this.code5))
                                                        && (this.normalizeCode(x.idProduct) === this.normalizeCode(this.idProduct)));
            if(index < 0) {
                let newProduct = {} as IPlanProducts;
                newProduct.code4 = this.code4;
                newProduct.code5 = this.code5;
                newProduct.idProduct = this.idProduct;
                newProduct.idHeader = this.planHeaderId;
                
                this.planProducts.push(newProduct);
                this.planProductsCount = this.planProductsCount + 1;

                this.code4 = null;
                this.code5 = null;
                this.idProduct = null;

                if(!this.isCollapseVisibile)
                    this.toggle();

                this.isSaveClicked = false;
                this.cleanAllSelection();
            } else {
                General.showAlertDanger(i18n.t('PPE.PRODUCT_ALREADY_INSERTED') as string, this);
            }
        }
    }

    async removeProduct(indexToDelete: number){
        this.planProducts.splice(indexToDelete, 1);
        this.planProductsCount = this.planProductsCount - 1;

        if(this.planProductsCount == 0 && this.isCollapseVisibile)
            this.toggle();
    }

    toggle(): void {
        this.isCollapseVisibile = !this.isCollapseVisibile;
    }

    get colorChange(){
        let color = '';
        if (!this.isCollapseVisibile)
            color = 'secondary';

        color = 'outline-secondary';
        return color;
    }

    getDisabledState() {
        if(this.editable) {
            if(this.allBrandsProp) {
                return true;
            } else {
                return false;
            }
        }
        else {
            return true; 
        }
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    normalizeCode(input: string): string {
        if(input == null) {
            return input;
        } else if(input == undefined || input.trim() === '') {
            return null;
        } else {
            return input;
        }
    }
}
